import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GuaranteeNotes } from "@app/models/guarantee-notes";
import { GuaranteeAgreementNotesService } from "@app/services/guarantee-agreement-notes.service";

@Component({
    selector: "app-guarantee-note-node",
    templateUrl: "./guarantee-note-node.component.html",
    styleUrls: ["./guarantee-note-node.component.css"],
    standalone: false
})
export class GuaranteeNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() guaranteeNotes: Array<GuaranteeNotes>;
  @Input() selectedGuaranteeNotes: Array<GuaranteeNotes>;
  @Output() onAddGuaranteeNote = new EventEmitter<GuaranteeNotes>();
  @Output() onDeleteGuaranteeNote = new EventEmitter<GuaranteeNotes>();

  constructor(private guaranteeNotesService: GuaranteeAgreementNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addGuaranteeNote(item);
    } else {
      this.deleteGuaranteeNote(item);
    }
  }

  addGuaranteeNote(item) {
    this.onAddGuaranteeNote.emit(item);
  }

  deleteGuaranteeNote(item) {
    this.onDeleteGuaranteeNote.emit(item);
  }

  isSelectedGuaranteeNote(item) {
    var parents = [];
    for (var i = 0; i < this.selectedGuaranteeNotes.length; i++) {
      var parents = parents.concat(this.guaranteeNotesService.findGuaranteeNoteParents(this.selectedGuaranteeNotes[i], this.guaranteeNotes));
    }
    var sParents = new Set(parents);
    return sParents.has(item);
  }
}
